import { menuGroup, menuItem } from "modules/helpers";

// components
import ExternalLink from "./ExternalLink.doc";

const components = [menuItem("<ExternalLink/>", "external-link", ExternalLink)];

export default [menuGroup("Components", "components", components)];
